import { observer } from 'mobx-react-lite'
import { useAnimationProgress } from '@/contexts/animation-progress-context'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'
import { type DocumentRootViewModel } from '@/features/documents/DocumentRootViewModel'
import { type MotionValue } from 'motion/react'

export interface DocumentsViewHeadingContainerProps {
  vm: DocumentRootViewModel
  compactionAnimationProgress?: MotionValue<number>
}

export const DocumentsViewHeadingContainer = observer(
  function DocumentsViewHeadingContainer({
    vm,
    compactionAnimationProgress,
  }: DocumentsViewHeadingContainerProps) {
    compactionAnimationProgress = useAnimationProgress(
      compactionAnimationProgress,
    )

    return (
      <WorkspaceSelectorViewHeadingContainer
        primaryText={'Documents Center'}
        allOptionText={'All Documents'}
        workspaces={vm.currentUserWorkspaces}
        dropdownTitle="View documents in"
        compactionAnimationProgress={compactionAnimationProgress}
        onChange={vm.selectWorkspaceForFiltering}
        value={vm.selectedWorkspace}
      />
    )
  },
)
